module.exports = __webpack_public_path__ + "img/dd_light_blue.b493586f.png";